module.exports = __webpack_public_path__ + "static/005-4435afa892abc84c4dee2b96b5f04f87.png";